export enum AssaygroupTypeEnum {
    OTHER = 'OTHER',
    CYTOLOGY = 'CYTOLOGY'
}

export interface CommonAssaygroupResponse {
    id: number,
    code: string,
    name: string,
    type: AssaygroupTypeEnum
}
